import React from "react";
import { Link } from "react-router-dom";

const Landing: React.FC = () => {
    const headline = React.useMemo(() => {
        return "Create private render farms using the computers you already have. Rent out your computer to others. All with Rend A Hand";
    }, []);

    return (
        <div className="container">
            <div className="jumbotron">
                <h1 className="display-4">Rend A Hand</h1>
                <p className="lead">{headline}</p>
                <hr className="my-4" />
                <Link
                    to="/welcome/sign-up"
                    className={"btn btn-lg btn-primary"}
                    role="button"
                >
                    Create Account
                </Link>
            </div>
            <h2>Questions?</h2>
            <p>
                Please feel free to reach out to us at{" "}
                <a href="mailto:info@rendahand.com">info@rendahand.com</a>
            </p>
        </div>
    );
};

export default Landing;
